import React, { useState, useEffect } from 'react';
import { Typography, Grid } from '@mui/material';
import { useApiRepo, Endpoints } from '../utils/Api';
import { GraphCard } from '../components/GraphCard';
import { Loading } from '../components/Loading';
import { ObsessionCompulsionFilter } from '../components/ObsessionCompulsionFilter';

interface IGraphEntry {
  user_id: string;
  obsession_id: string;
  obsession: string;
  compulsion_id: string;
  compulsion: string;
  data_set: Record<string, any>;
}

function getData(dataset: Record<string, any>, label: string[], key: string) {
  const values: any = [];
  if (label && dataset) {
    label.forEach((element: string) => {
      values.push(dataset[element][key]);
    });
  }
  return values;
}

function reportGraphs(graphEntry: IGraphEntry) {
  const labels = Object.keys(graphEntry.data_set);
  const resists = getData(graphEntry.data_set, labels, 'resist');
  const submits = getData(graphEntry.data_set, labels, 'submit');
  const competingResponses = getData(
    graphEntry.data_set,
    labels,
    'competing_response'
  );
  const datasets = [
    {
      label: 'Resists',
      data: resists,
      backgroundColor: '#0cd0cd',
      borderColor: '#0cd0cd'
    },
    {
      label: 'Submits',
      data: submits
    },
    {
      label: 'Competing Responses',
      data: competingResponses,
      backgroundColor: 'black',
      borderColor: 'black'
    }
  ];
  const data = {
    labels,
    datasets
  };
  return (
    <Grid item xs={12} key={graphEntry.compulsion_id}>
      <GraphCard
        obsession={graphEntry.obsession}
        compulsion={graphEntry.compulsion}
        data={data}
      />
    </Grid>
  );
}

export function Reports() {
  const { getObjectsFromAPI } = useApiRepo();
  const [chartData, setChartData] = useState<IGraphEntry[]>([]);
  const [filteredChartData, setFilteredChartData] = React.useState<
    IGraphEntry[]
  >([]);

  useEffect(() => {
    const fetchReportData = async () => {
      const api = await getObjectsFromAPI();
      const res = await api.get(Endpoints.banBookReport);

      setChartData(res.data.data);
      setFilteredChartData(res.data.data);
    };
    fetchReportData();
  }, []);

  function filterCharts(selectedObsession: any, selectedCompulsion?: any) {
    const filteredObsessions = chartData.filter(
      (entry: any) => entry.obsession_id === selectedObsession.id
    );
    if (selectedCompulsion) {
      const filteredCompulsions = filteredObsessions.filter(
        (entry: any) => entry.compulsion_id === selectedCompulsion.id
      );
      setFilteredChartData(filteredCompulsions);
      return;
    }
    setFilteredChartData(filteredObsessions);
  }

  return (
    <Grid
      container
      direction="row"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      style={{ padding: '60px' }}
    >
      <Grid item xs={12}>
        <Typography variant="h3" align="center" style={{ padding: '20px' }}>
          Reports
        </Typography>
      </Grid>
      <Grid
        container
        item
        maxWidth="xl"
        spacing={2}
        style={{ paddingBottom: '50px' }}
      >
        <Grid
          container
          item
          xs={12}
          direction="row"
          spacing={2}
          justifyContent="center"
        >
          <ObsessionCompulsionFilter handleFilter={filterCharts} />
        </Grid>
        <Grid container item spacing={3}>
          {filteredChartData ? (
            filteredChartData.map((element) => reportGraphs(element))
          ) : (
            <Loading />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
